import { find } from 'lodash';

export default function($state, $uibModalInstance, $log, UserClass, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  const companyInfo = ProfileClass.profileComplete.company;

  vm.$onInit = activate;

  vm.addCourse = () => {
    const course = vm.formData;
    return ApiClass.coursesPut({ manage: true }, { course })
      .then(courseReponse => {
        const course_id = courseReponse.data.course.course_id;
        $uibModalInstance.dismiss('cancel');
        $state.go('app.author.courses.course.edit', { id: UserClass.profile_uid, courseId: course_id });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.updateCourse = () => {
    if (!vm.scorm || !vm.courses) return (vm.formData = {});
    vm.formData = { name: vm.scormCourse.title, scorm_id: vm.scormCourse.id, type: 'scorm' };
  };

  vm.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };

  vm.searchScorm = filter => {
    vm.loaded = false;

    ApiClass.coursesAssetsScormGet(
      {},
      {},
      { queryParams: { manage: true, searchParams: JSON.stringify({ filter, filterBy: 'title' }) } }
    )
      .then(({ data: { courses } }) => {
        if (!courses || !courses.length) return (vm.loaded = true);
        vm.courses = courses;
        vm.scormCourse = vm.courses[0];
        vm.updateCourse();
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.info('Add Course Modal');
    vm.error = {};

    ApiClass.companiesIdTypeGet({ manage: true, id: companyInfo.company_id, type: 'integrations' }, null, {})
      .then(({ data: { items } }) => {
        vm.hasScorm =
          find(items, {
            integration_id: 'scorm'
          }) && find(items, { integration_id: 'scorm' }).active;
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/createCourse/index.js